import { useEffect, useState } from "react";
import API from "../../services/axiosInstance";
import { loggedInUserDetails } from "../utils/helper";
import SideBarCommon from "./sideBarCommon";
import { GLOBAL_MENU, PUBLISHER_MENU } from "./SidebarConfig";
import SideBarPub from "./sideBarPub";

const SideBar = ({ collapsed, menuItems, isMobile, onToggleSidebar }) => {
  const [pubMenu, setPubMenu] = useState([]);

  const user = loggedInUserDetails();

  const getAccountInfoByUserId = (id) => {
    try {
      // const response = await API.get(`/publisher/accounts/userid/${id}`);

      // if (response.status === 200) {
      //   const data = response.data.data;
      let id = localStorage.getItem("userId");
      let guid = localStorage.getItem("userGuid");

      setPubMenu([
        ...GLOBAL_MENU,
        ...PUBLISHER_MENU(guid, id).map(item => {
          return (
            { ...item }
          )
        }
        )
      ]);
      // setPubMenu([
      //   ...GLOBAL_MENU,
      //   ...PUBLISHER_MENU(data.userGuid, data.id).map(item => ({ ...item }))
      // ]);
      // // set some information into session 
      // localStorage.setItem("language", data.languageType);
      // }
    } catch (error) { } finally {
    }

  }



  useEffect(() => {
    if (user?.userId && user?.accountType == 1) {
      getAccountInfoByUserId(user.userId);
    }
  }, []);

  return (
    <>
      {
        user &&
          user.accountType == 1 ?
          <SideBarPub collapsed={collapsed} menuItems={pubMenu} isMobile={isMobile} onToggleSidebar={onToggleSidebar} />
          : <SideBarCommon collapsed={collapsed} menuItems={menuItems} isMobile={isMobile} onToggleSidebar={onToggleSidebar} />
      }
    </>
  );
}

export default SideBar;